import { render, staticRenderFns } from "./HomeProfessor.vue?vue&type=template&id=3d141008&"
import script from "./HomeProfessor.vue?vue&type=script&lang=js&"
export * from "./HomeProfessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports